import { QueryClient } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            gcTime: 24 * 60 * 60 * 1000, // keep unused cache for 24 hours
            retry: 2,
            refetchOnWindowFocus: false,
        },
    },
});

// Persist the entire query cache to localStorage so it survives page refreshes.
const localStoragePersister = createSyncStoragePersister({
    storage: window.localStorage,
    key: 'lms-query-cache',
    throttleTime: 1000,
});

persistQueryClient({
    queryClient,
    persister: localStoragePersister,
    maxAge: 24 * 60 * 60 * 1000,
});

export default queryClient;
